module.exports = __webpack_public_path__ + "img/1F62C.caf8d3fd.svg";